<app-navigation-header title="Property Report" i18n-title="@@propertyReport-propertyReportTitle">
	<app-data-set
		#dataSet
		[dataSource]="dataSource"
		defaultPresentationMode="table"
		[appBreadcrumbLabel]="breadcrumbLabel"
		[rowId]="rowId"
		firstColumnProperty="propertyName"
	>
		<app-data-set-toolbar>
			<div class="flex-space-around">
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						style="flex: 1"
						label="Refine Filters"
						i18n-label="@@propertyReport-refineFilters"
						svgIcon="sl-filter"
						(click)="onRefineFiltersClicked()"
						data-automation-id="property-report-refine-filters-button"
					></app-data-set-action-button>
				</div>
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						style="flex: 1"
						label="Download"
						i18n-label="@@propertyReport-downloadReport"
						svgIcon="sl-download"
						(click)="onDownloadClicked()"
						data-automation-id="property-report-download-button"
					></app-data-set-action-button>
				</div>
			</div>
		</app-data-set-toolbar>

		<app-data-set-content>
			<app-data-set-table-view>
				@if (
					loadingService.isLoading(generateAccessReportLoadingKey) ||
					loadingService.isLoading(generatePropertyReportCsvLoadingKey) ||
					!finishedLoadingInitData
				) {
					<app-data-set-loading-row />
				}
				<table
					mat-table
					[dataSource]="dataSource"
					matSortActive="devices"
					matSortDirection="desc"
					matSort
					[hidden]="
						loadingService.isLoading(generateAccessReportLoadingKey) ||
						loadingService.isLoading(generatePropertyReportCsvLoadingKey) ||
						!finishedLoadingInitData
					"
				>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
							No records found.
						</td>
					</tr>

					<ng-container matColumnDef="deviceSerialNumber">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyReport-serialNumber">Device</th>
						<td mat-cell *matCellDef="let row">{{ row.device }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceStatus">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyReport-deviceStatus">
							Device Status
						</th>
						<td mat-cell *matCellDef="let row">{{ this.getStatuses(row.deviceStatus) }}</td>
					</ng-container>

					@if (isCareCompany) {
						<ng-container matColumnDef="clientName">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyReport-client">Client</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientFirstName ?? '' }} {{ row?.clientLastName ?? '' }}</td>
						</ng-container>

						<ng-container matColumnDef="clientIdn">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyReport-clientIdn">Client IDN</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientIdn ?? '' }}</td>
						</ng-container>
					}

					<ng-container matColumnDef="propertyName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyReport-propertyName">
							Property Name
						</th>
						<td mat-cell *matCellDef="let row">{{ row.propertyName }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceLocation">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyReport-deviceLocation">
							Device Location
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceLocation }}</td>
					</ng-container>

					<ng-container matColumnDef="postalCode">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyReport-postalCode">Postal Code</th>
						<td mat-cell *matCellDef="let row">{{ row.postalCode }}</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
					<tr
						mat-row
						[ngClass]="{ 'code-visit': row.accessType === 'Code' }"
						*matRowDef="let row; columns: displayedColumns"
					></tr>
				</table>
			</app-data-set-table-view>
		</app-data-set-content>
	</app-data-set>
</app-navigation-header>
